import { createContext } from 'react';
import { AuthContextType } from './types';

export const AuthContext = createContext<AuthContextType>({
  token: null,
  signIn: () => Promise.resolve(false),
  signOut: () => null,
  error: undefined,
  loading: false,
  currentSlug: null,
});
